import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ProductEllipsisEvent,
  UnitsDropDownEvent,
} from '@app/mpp/model/ingredient-card-click-event';
import { IngredientUnitsCalculations } from '@app/mpp/model/recipe-detail-view-model';
import { PlatformEnum } from '@panamax/app-state';
import { Product } from '@shared/models/product.model';
import { EllipsisClickData } from '@shared/models/usf-product-card.model';

@Component({
  selector: 'app-ingredient-details',
  templateUrl: './ingredient-details.component.html',
  styleUrls: [
    './ingredient-details.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class IngredientDetailsComponent {
  @Input() readyToShow: boolean;
  @Input() product: Product;
  @Input() isOnline: boolean;
  @Input() marginTop: number;
  @Input() pricingDisabled = false;
  @Input() currentCalculations: IngredientUnitsCalculations;
  @Input() platform: PlatformEnum;
  @Input() showInfoIcon: boolean;
  @Input() lockEdits: boolean;
  @Input() isDefault: boolean;
  @Input() defaultItemName: string;
  @Output() goToDetails = new EventEmitter<Product>();
  @Output() closeEvent = new EventEmitter<void>();
  @Output() ellipsisEvent = new EventEmitter<EllipsisClickData>();
  @Output() productEvent = new EventEmitter<number>();
  @Output() baseQuantityEvent = new EventEmitter<number>();
  @Output() conversionQuantityEvent = new EventEmitter<number>();
  @Output() baseUnitEvent = new EventEmitter<UnitsDropDownEvent>();
  @Output() conversionUnitEvent = new EventEmitter<UnitsDropDownEvent>();
  @Output() resultUnitEvent = new EventEmitter<UnitsDropDownEvent>();
  @Output() saveChangesEvent = new EventEmitter<number>();
  @Output() infoIconEvent = new EventEmitter<Event>();

  selectedTab = 'unit-of-measure';
  platformRef = PlatformEnum;
  constructor() {}

  closeDetails() {
    this.closeEvent.emit();
  }

  onProductClick = ($event: number) => {
    this.productEvent.emit($event);
  };

  ellipsisClick($event: EllipsisClickData) {
    this.ellipsisEvent.emit($event);
  }

  updateBaseUnit(event: UnitsDropDownEvent) {
    this.baseUnitEvent.emit(event);
  }

  updateConversionUnit(event: UnitsDropDownEvent) {
    this.conversionUnitEvent.emit(event);
  }

  updateResultsUnit(event: UnitsDropDownEvent) {
    this.resultUnitEvent.emit(event);
  }

  updateBaseQunatity(value: number) {
    this.baseQuantityEvent.emit(value);
  }

  updateConversionQuantity(value: number) {
    this.conversionQuantityEvent.emit(value);
  }

  saveUnitsOfMeasureCalculation = () => {
    this.saveChangesEvent.emit(this.product?.summary?.netWeight);
  };

  clickInfoIcon = ($event: Event) => {
    this.infoIconEvent.emit($event);
  };
}
